<div
  class="header"
  *ngIf="
    globalService.footer.methodsPayment?.length
  "
>
  <p>Método de pago</p>
</div>
<div class="content"
>
  <img
    class="logo_entity"
    [src]="payment.url"
    [id]="payment.id"
    [alt]="payment.id"
    *ngFor="let payment of globalService.footer.methodsPayment"
  />
</div>
